import { KitType } from '@repo/types';

export function stoolToGut(sampleType: KitType) {
  return sampleType === 'stool' ? 'gut' : sampleType;
}
